import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorage {
    private localStorageExists: boolean;

    constructor() {
        this.localStorageExists = this.doesLocalStorageExist();
    }

    public set(key: string, value: string): void {
        if (this.localStorageExists) {
            window.localStorage.setItem(key, value);
        }
    }

    /* eslint-disable  @typescript-eslint/no-explicit-any */
    public get<T>(key: string): T {
        if (this.localStorageExists) {
            const value: any = window.localStorage.getItem(key);
            try {
                return JSON.parse(<string> value);
            } catch (error) {
                return <T> value;
            }
        }

        return;
    }
    /* eslint-enable  @typescript-eslint/no-explicit-any */

    public hasKey(key: string): boolean {
        if (this.localStorageExists) {
            return Boolean(this.get(key));
        }

        return false;
    }

    public destroy(key: string): void {
        if (this.localStorageExists) {
            window.localStorage.removeItem(key);
        }
    }

    private doesLocalStorageExist(): boolean {
        const testStorage: string = 'test';

        try {
            window.localStorage.setItem(testStorage, testStorage);
            window.localStorage.removeItem(testStorage);
        } catch (exception) {
            return false;
        }

        return true;
    }
}
